let rsaKeySize = [
  '2048',
  '4096'
]

export default rsaKeySize
